import { TagStationPage } from "../../pages/tag-station";

export const routeTagStation = "/tag-station";

export const tagStationRoutes = [
	{
		path: routeTagStation,
		element: <TagStationPage />,
	},
];
